import { useState, useEffect } from "react";

export type EditablePart = {
  titre: string;
  texte_narration: string;
  [key: string]: unknown;
};

export function useParagraphDragAndDrop(
  setParts: React.Dispatch<React.SetStateAction<EditablePart[]>>,
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>
) {
  const [heldTag, setHeldTag] = useState<string | null>(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [draggedIdx, setDraggedIdx] = useState<number | null>(null);
  const [dragOverIdx, setDragOverIdx] = useState<number | null>(null);

  useEffect(() => {
    if (!heldTag) return;
    const onMove = (e: MouseEvent) => setMousePos({ x: e.clientX, y: e.clientY });
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") setHeldTag(null);
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("keydown", onEsc);
    };
  }, [heldTag]);

  const handleDrop = (targetIdx: number) => {
    if (draggedIdx === null || draggedIdx === targetIdx) return;
    setParts((prev) => {
      const next = [...prev];
      const [moved] = next.splice(draggedIdx, 1);
      next.splice(targetIdx, 0, moved);
      return next;
    });
    setIsDirty(true);
    setDraggedIdx(null);
    setDragOverIdx(null);
  };

  return {
    heldTag,
    setHeldTag,
    mousePos,
    draggedIdx,
    setDraggedIdx,
    dragOverIdx,
    setDragOverIdx,
    handleDrop,
  };
}
